import useScript from './useScript.js'
export default function useFomo() {
  //src is fomo script url
  const src = 'https://load.fomo.com/api/v1/AyfaUR4xzGMFL4nPZyTXFg/load.js';
  useScript(src);
}